import React, { Suspense, useEffect, useState } from "react";
// import Banners from 'src/components/Banner/index';
// import MultipleItems from 'src/components/slick-slider';
// import TopGames from "src/components/top-games/index";
// import HomeExchange from "src/components/home-exchange/index";
//import HomePopular from "src/components/home-popular/index";
// import CenterMode from "src/components/LiveDealerCraousel/index"
// import LiveGamesWrapper from "src/components/home-live-games/index";
// import BBBEdge from 'src/components/BBBEdge/index';
// import FlagsContainer from "src/components/flags/flags";
import { getBrandId, withAppContext } from "src/store/initAppContext";
import withSystem from "src/HOC/withSystem";
import styled, { withTheme } from "styled-components";
// import BonusHomepage from 'src/components/udb/bonus/BonusHomepage';
// import LoyaltyHomeComponent from 'src/components/Loyalty/HomeLoyalty';
// import styled from "styled-components";
import { CRMLoginSuccess, CRMPageVisit, CRMRegistrationSuccess } from "src/util/crmUtil";

import { homePageSEOData } from "src/config/seo_api";
import { MetaProps, SEOFooterCommon, SEOMetaCommon } from "src/components/SEOMetaCommon";
import { useLocation } from "react-router-dom";
import { addressablePxlInit } from "src/util/addressablePxl";
import config from "src/config/config";
import { theme } from "styled-tools";
// import LeaderBoard from "src/components/leaderboard";

const Banners = React.lazy(() => import("src/components/Banner/index"));
const MultipleItems = React.lazy(() => import("src/components/slick-slider"));
const TopGames = React.lazy(() => import("src/components/top-games/index"));
const HomeExchange = React.lazy(() => import("src/components/home-exchange/index"));
const BonusHomepage = React.lazy(() => import("src/components/udb/bonus/BonusHomepage"));
const LoyaltyHomeComponent = React.lazy(() => import("src/components/Loyalty/HomeLoyalty"));
const CenterMode = React.lazy(() => import("src/components/LiveDealerCraousel/index"));
const LiveGamesWrapper = React.lazy(() => import("src/components/home-live-games/index"));
const FlagsContainer = React.lazy(() => import("src/components/flags/flags"));
const BBBEdge = React.lazy(() => import("src/components/BBBEdge/index"));
const SeoContentHomePage = React.lazy(() => import("src/components/seo-content/seo_content"));
const WhatsappIco = React.lazy(() => import("src/components/WhatsappIco"));
const GamesLobby = React.lazy(() => import('src/components/games-lobby/index'))

function Home(props: any) {
  const { theme, app: { brandId } } = props;
  const { config: {
    showBBEedge,
    showCenterMode,
    showHomebanners,
    showLiveGamesWrapper,
    showSEOdropdown,
    showcasinoslider,
    showTopGamesSection,
    showFlags,
    showWhatsAppAfterLogin,
    showNotcasinoslider,
    showGamesLobby,
    showAPISEOData
  } } = theme;

  const [seoObjects, setseoObjects] = useState({} as MetaProps);
  const _location = useLocation();


  useEffect(() => {
    const t = setTimeout(() => {
      CRMPageVisit();

      const isjustLogin = sessionStorage.getItem('uin');

      if (isjustLogin) {
        const { brandId, username, memberId, isreg } = JSON.parse(decodeURI(isjustLogin));

        if (isreg) {
          CRMRegistrationSuccess(brandId, username, memberId);
        } else {
          CRMLoginSuccess(brandId, username, memberId);
        }

        // Schedule removal only after processing
        setTimeout(() => {
          sessionStorage.removeItem('uin');
        }, 10000); // Adjust timing as needed
      }
    }, 300);

    //addressablePxl Init
    addressablePxlInit(brandId);

    return () => clearTimeout(t);
  }, []);

  //for SEO
  useEffect(() => {
    if (showAPISEOData) {
      const getSeoData = homePageSEOData();

      getSeoData.then(resp => {

        const pathName = _location.pathname;
        const { objects } = resp;

        const seoData = objects.find((obj: any) => {
          const { metadata = {} } = obj;
          if (metadata.pathname && metadata.pathname === pathName) {
            return obj;
          }

        }) || {};

        const { metadata = {} } = seoData;
        setseoObjects(metadata);

      }).catch(error => console.log('Error in Home page SEO'))

    }
  }, []);

  return (
    <HomePageWrapper>
      {showAPISEOData && (<SEOMetaCommon metaData={seoObjects} />)}

      <Suspense fallback={<div>Loading...</div>}>
        {showcasinoslider && <MultipleItems />}
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        {showHomebanners && <Banners />}
      </Suspense>
      {<Suspense fallback={<div>Loading...</div>}>
        {showNotcasinoslider && <MultipleItems />}
      </Suspense>}
      {<Suspense fallback={<div>Loading...</div>}>
        {showGamesLobby && <GamesLobby />}
      </Suspense>}
      <Suspense fallback={<div>Loading...</div>}>
        {showTopGamesSection && <TopGames />}
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        <HomeExchange />
      </Suspense>

      <Suspense fallback={<div>Loading...</div>}>
        <BonusHomepage />
      </Suspense>


      {/* <HomePopular /> */}
      {/* <LoyaltyHomeComponent/> */}

      <Suspense fallback={<div>Loading...</div>}>
        <LoyaltyHomeComponent />
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        {showCenterMode && <CenterMode />}
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        {showLiveGamesWrapper && <LiveGamesWrapper />}
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        {showBBEedge && <BBBEdge />}
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        {showFlags && <FlagsContainer />}
      </Suspense>

      {showAPISEOData && <SEOFooterCommon footer_title={seoObjects['seo_footer_title_(h1)']} footer_content={seoObjects['seo_footer_content']} />}

      {showWhatsAppAfterLogin && <Suspense fallback={<div>Loading...</div>}> <WhatsappIco /></Suspense>}

    </HomePageWrapper>
  );
}

export default withAppContext(withTheme(Home));


const HomePageWrapper = styled.div`
  width: 100%;
  height: auto;
  background-image: url(${config.imageV3Host}/static/cashsite/${theme("image.homePageMainBgImage")});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top right;
  background-attachment: fixed;
`;
